var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5198C0 8.75027 8.73045 0 19.5 0C30.2696 0 39 8.75026 39 19.5198C39 30.2675 30.2477 39 19.5 39C8.75231 39 0 30.2675 0 19.5198Z",
    fill: "#9A469B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80078 7.80029H31.2008V19.5003C31.2008 25.962 25.9625 31.2003 19.5008 31.2003V31.2003C13.039 31.2003 7.80078 25.962 7.80078 19.5003V7.80029Z",
    fill: "#9A469B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0895 19.5002H19.502M9.75195 17.5502H11.702M9.75195 21.4503H11.702M17.0191 11.9541L27.969 17.4257C29.6796 18.2805 29.6796 20.72 27.969 21.5748L17.0191 27.0464C15.0716 28.0196 12.9761 26.0184 13.8604 24.0299L15.4559 20.4423C15.7226 19.8425 15.7226 19.158 15.4559 18.5582L13.8604 14.9706C12.9761 12.9821 15.0716 10.9809 17.0191 11.9541Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.b30506e347ccf4819a7eb527eb0b1b85.svg";
export { ForwardRef as ReactComponent };